<template>
  <el-dropdown
    ref="querySymbolNode"
    class=""
    trigger="click"
    :teleported="true"
    :hide-on-click="false"
    :popper-class="`dropdown-no-arrow QuerySymbol-m rounded-12px m-t-3 new-style ${configStore.tradeStyle}`"
    placement="bottom-start"
    @visible-change="visibleChange"
  >
    <Row ref="queryInputDom" class="w-32px h-32px pointer" x="c" y="c">
      <!-- <IconSvg class="font-22 text-white" name=÷"icon-IconSearch" /> -->
      <Row class="w-32px h-32px header-round-hover-bg rd-full" x="c" y="c">
        <img class="w-20px" src="@/image/home/query.svg">
      </Row>
    </Row>
    <template #dropdown>
      <Column class="w-100% QuerySymbol-center px-16px p-t-16px p-b-12px">
        <Row class="w-100b h-40px position-r bg-lInfo rounded-full">
          <Column class="position-a left-0 top-0 h-40px z-10 p-l-16px" y="c">
            <img class="w-20px h-20px" src="@/image/home/search-popup.png" alt="">
          </Column>
          <Column v-if="searchText.length > 0" class="position-a right-0 top-0 h-40px z-10 p-r-16px" y="c" @click.stop="clearText">
            <IconSvg class="font-16 text-ccc" name="icon-IconDelete_Input" />
          </Column>
          <el-input
            ref="searchTextNode"
            v-model="searchText"
            class="font-14 w-100b h-40px position-a left-0 top-0 QuerySymbol-input rounded text-16151A"
            :placeholder="$t('table.search')"
            @keydown.enter.stop.prevent="handleEnter"
            @keydown.space.stop
          />
        </Row>
      </Column>
      <Row class="w-100% QuerySymbol-center">
        <el-tabs v-if="searchText" v-model="tabValue" class="w-100b tabs position-r top-5 m-b-4">
          <el-tab-pane v-for="(item) in tabValueOptions" :key="item.label" :label="item.label" :name="item.value">
            <template #label>
              <Row class="">
                <span class="font-14">{{ item.label }}</span>
              </Row>
            </template>
          </el-tab-pane>
        </el-tabs>
      </Row>
      <el-scrollbar id="sss" :max-height="DROPDOWN_MAX_HEIGHT - SEARCH_INPUT_HEIGHT - (searchText ? SEARCH_TABS_HEIGHT : 0)" wrap-class="w-380 column QuerySymbol-center p-b-10 rounded">
        <Column v-if="searchText" class="w-100b">
          <Column v-if="!hasSearchResults" class="w-100b p-tb-95" y="s" x="c">
            <ListEmpty class="p-tb-25" :size="78" :text="$t('table.noResultsFound')" />
          </Column>
          <template v-else>
            <component
              :is="section.component"
              v-for="section in visibleSearchSections"
              :key="section.value"
              :showNum="SEARCH_RESULT_SHOW_NUM"
              v-bind="section.props"
              :tiitle="section.title"
              :tabValue="tabValue"
              @update:searchHistory="updateSearchHistory"
            >
              <template #tiitleRight>
                <IconSvg v-if="tabValue == TAB_VALUES.ALL" name="icon-IconArrowRight_Home" class="font-18 pointer c-border" @click="() => tabValueChange(section.value)" />
              </template>
            </component>
          </template>
        </Column>
        <Column v-if="!searchText" class="w-100b">
          <Column v-if="searchHistory.length > 0" class="w-100b p-lr-16">
            <Row class="w-100b p-t-16 p-b-12" x="sb">
              <span class="font-16 font-w-700">{{ $t('trade.searchHistory') }}</span>
              <!-- <el-icon class="font-14 text-9b pointer" @click="deleteSearchHistory"><IconDelete /></el-icon> -->
              <img class="w-20px h-20px pointer" src="@/image/home/trash-popup.png" alt="" @click="deleteSearchHistory">
            </Row>
            <Row class="w-100b f-wrap" x="s">
              <Row
                v-for="item in searchHistory.slice(0, SEARCH_HISTORY_LIMIT)"
                :key="`${item.coinMarket}-${getSearchHistoryRoute(item)}`"
                class="p-lr-8 h-28 m-r-8 m-b-8 bg-lInfo radius-4 font-12 pointer"
                x="c"
                y="c"
                @click="() => toTrade(item)"
              >
                <span class="text-16151A">{{ item.coinMarket }}</span>
                <span v-if="isSearchHistoryFutures(item)" class="">{{ $t('futures.perpetual') }}</span>
              </Row>
            </Row>
          </Column>
          <QuerySymbolList
            :key="tabType + 'QuerySymbolList'"
            :showNum="showNum"
            :list="lists[tabType]?.slice(0, limitLength)"
            :tiitle="$t('trade.topTrade')"
            titleClass="text-16px weight-700"
            :tabType="tabType"
            :searchHistory="searchHistory"
            @update:searchHistory="updateSearchHistory"
          >
            <template #a1>
              <Row class="w-100% p-lr-16">
                <Row
                  class="h-28 p-lr-8 radius-4 m-r-8 pointer"
                  :class="tabType == MARKET_TYPE.SPOT ? 'bg-primary c-white' : 'bg-lInfo text-16151A'"
                  x="c"
                  y="c"
                  @click="() => tabType = MARKET_TYPE.SPOT"
                >{{ $t('public.spot') }}</Row>
                <Row
                  class="h-28 p-lr-8 radius-4 m-r-8 pointer"
                  :class="tabType == MARKET_TYPE.FUTURES ? 'bg-primary c-white' : 'bg-lInfo text-16151A'"
                  x="c"
                  y="c"
                  @click="() => tabType = MARKET_TYPE.FUTURES"
                >{{ $t('futures.yfutures') }}</Row>
              </Row>
            </template>
          </QuerySymbolList>
          <Row class="w-100b p-lr-16 p-t-16 p-b-12 " x="sb">
            <span class="font-16 font-w-700">{{ $t('trade.trendingEarn') }}</span>
            <Row>
              <IconSvg name="icon-IconArrowLeft_Home" class="font-18 pointer m-r-5" :class="financialListStart == 0 ? 'c-lInfo' : 'c-border'" @click="financialListStartChange(DIRECTION.PREV)" />
              <IconSvg name="icon-IconArrowRight_Home" class="font-18 pointer" :class="financialListStart == financialList.length - financialListNum ? 'c-lInfo' : 'c-border'" @click="financialListStartChange(DIRECTION.NEXT)" />
            </Row>
          </Row>
          <Row class="w-100% p-lr-16 p-b-10" x="sb">
            <Column v-for="item in financialList.slice(financialListStart, financialListStart + financialListNum)" :key="item.coinName" class="w-109 f-size-109 p-12 bg-f9! radius-6 pointer" @click="() => toFinancial(item)">
              <el-image class="w-22 h-22 radius-50b m-b-4" :src="quotesStore.coinImageMap[item.coinName]">
                <template #placeholder>
                  <el-image class="w-22 h-22 " :src="coinDefaultImage" />
                </template>
                <template #error>
                  <el-image class="w-22 h-22 " :src="coinDefaultImage" />
                </template>
              </el-image>
              <span class="font-14 font-w-700 text-16151A m-b-12">{{ item.coinName }}</span>
              <span class="text-12px text-9b m-b-4">{{ $t('home.estAPR') }}</span>
              <span class="font-14 font-w-700 c-success">{{ item.incomeRatio }}%</span>
            </Column>
          </Row>
        </Column>
      </el-scrollbar>
    </template>
  </el-dropdown>
</template>

<script setup>
import coinDefaultImage from '@/image/coinDefaultImage.webp'
import QuerySymbolList from './QuerySymbolList.vue'
import QuerySymbolEarnList from './QuerySymbolEarnList.vue'
import { useFuse } from '@vueuse/integrations/useFuse'
import { createFuseOptions } from '@/utils/hook/fuse'
import { useSpotTickers } from '@/hook/useSpotTicker.js'

const useFuseOptions = createFuseOptions(['coinMarket', 'coinName', 'stockNumSearch'])

const TAB_VALUES = {
  ALL: '1',
  SPOT: '2',
  FUTURES: '3',
  FINANCIAL: '4',
  STOCK: '5',
  STOCK_FUTURES: '6',
}

const MARKET_TYPE = {
  SPOT: 1,
  FUTURES: 2,
}

const ROUTE_PATHS = {
  SPOT: '/trade',
  FUTURES: '/futures',
  STOCK: '/coinStockTrade',
  STOCK_FUTURES: '/coinStockFutures',
}

const DIRECTION = {
  PREV: -1,
  NEXT: 1,
}

const SEARCH_RESULT_SHOW_NUM = 3
const FINANCIAL_CARD_PAGE_SIZE = 3
const TOP_TRADE_SHOW_NUM = 5
const DEFAULT_LIST_LIMIT = 20
const SEARCH_HISTORY_LIMIT = 6
const DROPDOWN_MAX_HEIGHT = 900
const SEARCH_INPUT_HEIGHT = 72
const SEARCH_TABS_HEIGHT = 48

const props = defineProps({
  show: {},
  type: {},
  targetDom: {},
  isSmallScreen: {
    type: Boolean,
    default: false,
  },
})
const quotesStore = useQuotesStore()
const configStore = useConfigStore()

let searchText = $ref('')
let searchHistory = $ref([])
let dropdownVisible = $ref(false)
const spotTickers = useSpotTickers({ enabled: () => dropdownVisible })

const updateSearchHistory = (value) => {
  searchHistory = value
  localStorage.searchHistory = JSON.stringify(searchHistory)
}

const tabType = $ref(MARKET_TYPE.SPOT)
// const showDropdown = $ref(false)
const searchTextNode = $ref()
const querySymbolNode = $ref()
let tabValue = $ref(TAB_VALUES.ALL)

const showNum = TOP_TRADE_SHOW_NUM
const limitLength = DEFAULT_LIST_LIMIT

let financialList = $ref([])
let financialListStart = $ref(0)
const financialListNum = FINANCIAL_CARD_PAGE_SIZE

const isStockItem = item => ['HK', 'US'].includes(item?.stockType)
const getSearchHistoryRoute = item => item?.routePath || (item?.type == MARKET_TYPE.SPOT ? ROUTE_PATHS.SPOT : ROUTE_PATHS.FUTURES)
const isSearchHistoryFutures = item => [ROUTE_PATHS.FUTURES, ROUTE_PATHS.STOCK_FUTURES].includes(getSearchHistoryRoute(item))

const getStockNumSearch = item => item?.stockNum?.toUpperCase?.() ?? ''

const createIndexedList = (list = []) => {
  return Array.from(new Map(list.map((e, i) => [e.coinMarket, {
    ...e,
    sIndex: i + 1,
    stockNumSearch: getStockNumSearch(e),
  }])).values())
}

const getList = (list = []) => {
  return createIndexedList(searchText ? list : list.filter(item => item.isHot))
}

const lists = $computed(() => {
  return {
    [MARKET_TYPE.SPOT]: getList(spotTickers.value),
    [MARKET_TYPE.FUTURES]: getList(quotesStore.contractTickers),
  }
})

const spotSearchBaseList = $computed(() => createIndexedList((spotTickers.value || []).filter(item => !isStockItem(item))))
const futuresSearchBaseList = $computed(() => createIndexedList((quotesStore.contractTickers || []).filter(item => !isStockItem(item))))
const stockSearchBaseList = $computed(() => createIndexedList((spotTickers.value || []).filter(item => isStockItem(item))))
const stockFuturesSearchBaseList = $computed(() => createIndexedList((quotesStore.contractTickers || []).filter(item => isStockItem(item))))

const { results: spotFuseResults } = useFuse($$(searchText), computed(() => spotSearchBaseList || []), useFuseOptions)
const { results: futuresFuseResults } = useFuse($$(searchText), computed(() => futuresSearchBaseList || []), useFuseOptions)
const { results: stockFuseResults } = useFuse($$(searchText), computed(() => stockSearchBaseList || []), useFuseOptions)
const { results: stockFuturesFuseResults } = useFuse($$(searchText), computed(() => stockFuturesSearchBaseList || []), useFuseOptions)
const { results: financialFuseResults } = useFuse($$(searchText), $$(financialList), useFuseOptions)

const spotSearchList = $computed(() => searchText ? spotFuseResults.value.map(item => item.item) : (spotSearchBaseList || []))
const futuresSearchList = $computed(() => searchText ? futuresFuseResults.value.map(item => item.item) : (futuresSearchBaseList || []))
const stockSearchList = $computed(() => searchText ? stockFuseResults.value.map(item => item.item) : (stockSearchBaseList || []))
const stockFuturesSearchList = $computed(() => searchText ? stockFuturesFuseResults.value.map(item => item.item) : (stockFuturesSearchBaseList || []))
const financialSearchList = $computed(() => searchText ? financialFuseResults.value.map(item => item.item) : financialList)
const searchSections = $computed(() => {
  return [
    {
      value: TAB_VALUES.STOCK,
      title: $t('stock.stockTab'),
      component: QuerySymbolList,
      props: { list: stockSearchList, tabType: MARKET_TYPE.SPOT, optional: true, searchHistory },
    },
    {
      value: TAB_VALUES.STOCK_FUTURES,
      title: $t('stock.stockContractTab'),
      component: QuerySymbolList,
      props: { list: stockFuturesSearchList, tabType: MARKET_TYPE.FUTURES, optional: true, searchHistory },
    },
    {
      value: TAB_VALUES.SPOT,
      title: $t('public.spot'),
      component: QuerySymbolList,
      props: { list: spotSearchList, tabType: MARKET_TYPE.SPOT, optional: true, searchHistory },
    },
    {
      value: TAB_VALUES.FUTURES,
      title: $t('futures.yfutures'),
      component: QuerySymbolList,
      props: { list: futuresSearchList, tabType: MARKET_TYPE.FUTURES, optional: true, searchHistory },
    },
    {
      value: TAB_VALUES.FINANCIAL,
      title: $t('header.financial'),
      tabLabel: $t('trade.trendingEarn'),
      component: QuerySymbolEarnList,
      props: { list: financialSearchList },
    },
  ]
})
const tabValueOptions = $computed(() => {
  return [
    { label: $t('table.sideOptions.all'), value: TAB_VALUES.ALL },
    ...searchSections.map(section => ({ label: section.tabLabel || section.title, value: section.value })),
  ]
})
const visibleSearchSections = $computed(() => {
  return searchSections.filter(section => tabValue == section.value || (tabValue == TAB_VALUES.ALL && section.props.list?.length != 0))
})
const hasSearchResults = $computed(() => {
  return searchSections.some(section => section.props.list?.length > 0)
})

const tabValueChange = (value) => {
  tabValue = value
}

const getFinancialList = async () => {
  try {
    const data = await financialApi.financialList({})
    financialList = data?.slice(0, limitLength) || []
  } catch (error) {
    financialList = []
    console.error('getFinancialList error', error)
  }
}

const financialListStartChange = (n) => {
  if (n == DIRECTION.PREV && financialListStart != 0) {
    financialListStart += n
    return
  } else if (n == DIRECTION.NEXT && (financialListStart * financialListNum) <= financialList.length) {
    financialListStart += n
    return
  }
}

const toTrade = (item) => {
  router.push({
    path: getSearchHistoryRoute(item),
    query: {
      symbol: item.coinMarket,
    },
  })
}

const clearText = () => {
  searchText = ''
  searchTextNode?.focus?.()
  querySymbolNode.handleOpen()
}

const visibleChange = (show) => {
  dropdownVisible = show
  if (show == false) {
    searchText = ''
    searchTextNode?.clear?.()
    searchTextNode?.blur?.()
  } else {
    nextTick(() => {
      searchTextNode?.focus?.()
    })
  }
}

const toFinancial = (item) => {
  router.push({
    path: '/financial',
    query: {
      coinId: item.coinId
    },
  })
}

watch(() => tabType, () => {
  financialListStart = 0
})

watch(() => searchText, () => {
  tabValue = TAB_VALUES.ALL
})

const deleteSearchHistory = () => {
  searchHistory = []
  localStorage.searchHistory = ''
}

const handleEnter = (e) => {
  e.preventDefault()
  e.stopPropagation()
  // 如果需要在回车时执行某些操作，可以在这里添加
}

onBeforeMount(() => {
  if (localStorage.searchHistory) {
    searchHistory = isJsonString(localStorage?.searchHistory) ? JSON.parse(localStorage?.searchHistory) : []
  }

  quotesStore.getContractTickers()
  getFinancialList()
})

onMounted(() => {

})

</script>

<style lang="scss">

.QuerySymbol-input {
  .el-input__wrapper {
    padding-left: 48px !important;
    padding-right: 44px !important;
    border-radius: 999px !important;
    box-shadow: 0 0 0 1px transparent inset !important;
    background: transparent !important;

    &:hover,
    &.is-focus {
      box-shadow: 0 0 0 1px var(--el-color-primary) inset !important;
    }
  }
  .el-input__inner {
    font-size: 12px !important;
    height: 40px !important;

    &::-webkit-input-placeholder {
      color: #CCCCCC !important;
      font-size: 12px !important;
    }
    &::placeholder {
      color: #CCCCCC !important;
      font-size: 12px !important;
    }
  }
}
.QuerySymbol-m{
  .el-dropdown__list{
    padding: 0!important;
  }
}
.QuerySymbol-center{
  .el-tabs__header{
    margin-bottom: 0 !important;
  }
  .el-tabs__nav{
    padding: 0 9px !important;
  }

  .el-tabs__nav-wrap::after{
    height: 1px !important;
    background-color: var(--input-bg-color);
  }
  .el-tabs__item{
    --el-tabs-header-height: 48px;
    padding: 0 7px !important;
  }
  .el-tabs__active-bar{

  }
  .el-tabs__item.is-active{
    font-weight: bold !important;
  }

}
</style>
